import { ModuleWithProviders, NgModule } from '@angular/core'
import { SharedModule } from '../shared/shared.module'

import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'

import { reducer } from './reducers'

import { CartEffects } from './effects/cart-effects'
import { CartService } from './services/cart-service'

@NgModule({
  imports: [
    SharedModule
  ]
})
export class CartModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: RootCartModule,
      providers: [
        CartService
      ]
    }
  }
}

@NgModule({
  imports: [
    CartModule,
    StoreModule.forFeature('cart', reducer),
    EffectsModule.forFeature([
      CartEffects
    ])
  ]
})
export class RootCartModule {}
